import axios from "axios";
class ParseAxios {
  constructor() {
    this.baseURL = process.env.VUE_APP_SERVER_URL || "https://market-parse-dev-eir4oz44ca-as.a.run.app/parse";
    this.appId = process.env.VUE_APP_APP_ID || "V1raJlLkYEc8UEim9jRNQqm2dcXKHlpj";
  }
  post(url, data) {
    let option = {
      method: 'POST',
      url: `${this.baseURL}/${url}`,
      data: data,
      headers: { 'X-Parse-Application-Id': this.appId },
    }
    if (localStorage.getItem("sessionToken")) {
      option.headers["X-Parse-Session-Token"] = localStorage.getItem("sessionToken")
    } else {
      option.headers["X-Parse-Session-Token"] = ""
    }
    return axios(option)
  }
  get(url) {
    let option = {
      method: 'GET',
      url: `${this.baseURL}/${url}`,
      headers: { 'X-Parse-Application-Id': this.appId },
    }
    if (localStorage.getItem("sessionToken")) {
      option.headers["X-Parse-Session-Token"] = localStorage.getItem("sessionToken")
    } else {
      option.headers["X-Parse-Session-Token"] = ""
    }
    return axios(option)
  }
}
export default new ParseAxios();
